/**
 * El panel de mover cita, en recuadro: el del detalle, para el soltar del mes.
 *
 * El clic que abre esto (el del menú) a veces acaba en el fondo y lo cerraría
 * en el mismo instante. Los primeros milisegundos el fondo no cierra.
 */
import { useEffect, useRef } from 'react'

import { BotonMoverCita } from './calendario-mover'

export function DialogoMoverCita({
    accountId,
    citaId,
    dia,
    horaInicio,
    minutos,
    profesionalId,
    alCerrar,
}: {
    accountId: string
    citaId: number
    dia: string
    horaInicio: string
    minutos: number
    profesionalId: number | null
    alCerrar: () => void
}) {
    const yaSePuedeCerrar = useRef(false)

    useEffect(() => {
        const t = window.setTimeout(() => {
            yaSePuedeCerrar.current = true
        }, 250)
        return () => window.clearTimeout(t)
    }, [])

    function fondo() {
        if (yaSePuedeCerrar.current) alCerrar()
    }

    return (
        <div
            className="fixed inset-0 z-[60] flex items-end justify-center overflow-y-auto bg-black/60 p-3 pt-[max(4.5rem,env(safe-area-inset-top))] sm:items-start sm:p-4 sm:pt-16"
            onClick={fondo}
            role="presentation"
            data-testid="dialogo-mover-cita"
        >
            <div
                role="dialog"
                aria-modal="true"
                aria-labelledby="mover-cita-titulo"
                className="mb-[max(0.5rem,env(safe-area-inset-bottom))] max-h-[min(90dvh,40rem)] w-full max-w-lg overflow-y-auto rounded-lg border border-neutral-700 bg-neutral-900 p-4 shadow-xl sm:mb-0"
                onClick={(e) => e.stopPropagation()}
            >
                <h3 id="mover-cita-titulo" className="mb-3 text-base font-medium text-neutral-100">
                    Mover cita
                </h3>
                <BotonMoverCita
                    accountId={accountId}
                    citaId={citaId}
                    dia={dia}
                    horaInicio={horaInicio}
                    minutos={minutos}
                    profesionalId={profesionalId}
                    forzarAbierto
                    alHecho={alCerrar}
                />
                <div className="mt-3 flex justify-end">
                    <button
                        type="button"
                        onClick={alCerrar}
                        className="rounded-md border border-neutral-700 px-3 py-1.5 text-sm text-neutral-300 hover:bg-neutral-800 hover:text-neutral-100"
                    >
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    )
}
